import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { dateValidator, NHSnumberValidator } from '@Utils';

@Component({
  selector: 'app-search-form',
  imports: [ReactiveFormsModule],
  templateUrl: './search-form.component.html',
  styleUrl: './search-form.component.css',
})
export class SearchFormComponent implements OnInit {
  searchForm!: FormGroup;
  formSubmitted = false;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _fb: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.searchForm = this._fb.group(
      {
        nhsNumber: ['', NHSnumberValidator()],
        forename: [''],
        surname: [''],
        startDateDoB: ['', dateValidator()],
        endDateDoB: ['', dateValidator()],
        postcode: [''],
        address: [''],
        immunisationStatus: ['-1'],
        pageNumber: 1,
      },
      { updateOn: 'submit' },
    );

    this._route.queryParams.subscribe((params) => {
      Object.keys(params).forEach((key) => {
        if (this.searchForm.contains(key)) {
          this.searchForm.get(key)?.setValue(params[key]);
        }
      });
    });
  }

  onSubmit() {
    this.formSubmitted = true;
    const formValues = { ...this.searchForm.value };

    // Clean the NHS number by removing spaces and hyphens if it exists
    if (formValues.nhsNumber) {
      formValues.nhsNumber = formValues.nhsNumber.toString().replace(/[\s-]/g, '');
    }

    const queryParams = Object.keys(formValues)
      .filter((key) => formValues[key] !== null && formValues[key] !== '' && formValues[key] !== '-1')
      .reduce((obj: Record<string, string | number | boolean | null>, key: string) => {
        obj[key] = formValues[key];
        return obj;
      }, {});

    queryParams['pageNumber'] = 1;

    this._router
      .navigate([`/search`], {
        queryParams,
      })
      .then(() => {
        (document.activeElement as HTMLElement).blur();
      });
  }

  isNotEmpty(controlName: string): boolean {
    const control = this.searchForm.get(controlName);
    return control && control.value && control.value.trim() !== '' && control.value !== '-1';
  }

  clearFilters() {
    this.searchForm.reset();
    (document.activeElement as HTMLElement).blur();
  }

  shouldDisplayField(type: string): boolean {
    const searchType = 'SearchForm';
    const childSearchFields = ['nhsNumber', 'forename', 'surname', 'startDateDoB', 'endDateDoB', 'address'];

    if (searchType === 'SearchForm') {
      return childSearchFields.includes(type);
    } else if (searchType === 'dashboard') {
      return true;
    }

    return false;
  }
}
